module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Documentation NOC & AUTH")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "vehicleBooking"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    attrs: {
      "id": "showVisibility"
    },
    on: {
      "click": _vm.showOverflow
    }
  }, [_c('span', [_vm._v("Documentation - Noc")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Current Date & Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.NocModel.currentDate),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "currentDate", $$v)
      },
      expression: "NocModel.currentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Importer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "importerName",
      "name": "importerName"
    },
    model: {
      value: (_vm.NocModel.importerName),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "importerName", $$v)
      },
      expression: "NocModel.importerName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("HBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "hblNo",
      "name": "hblNo"
    },
    model: {
      value: (_vm.NocModel.hblNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "hblNo", $$v)
      },
      expression: "NocModel.hblNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("MBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo",
      "name": "mblNo"
    },
    model: {
      value: (_vm.NocModel.mblNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "mblNo", $$v)
      },
      expression: "NocModel.mblNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Preparation of NOC for Shipping Line")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "530px !important"
    },
    model: {
      value: (_vm.NocModel.nocPreparation),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "nocPreparation", $$v)
      },
      expression: "NocModel.nocPreparation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderNoc"
    },
    on: {
      "click": _vm.addNocDocumentation
    }
  }, [_vm._v("Submit Noc")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderNoc"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), (_vm.NocModel.ffNocId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderAuth"
    },
    on: {
      "click": function($event) {
        _vm.Print('ConNocDoc', _vm.NocModel.uploadNocDoc)
      }
    }
  }, [_vm._v("Print")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-viewport",
    attrs: {
      "id": "railOut"
    }
  }, [_c('div', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    attrs: {
      "id": "showvehicleBooking"
    }
  }, [_c('span', [_vm._v("Documentation ­ Authorization Letter")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Importer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "importerName",
      "name": "importerName"
    },
    model: {
      value: (_vm.AuthModel.importerName),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "importerName", $$v)
      },
      expression: "AuthModel.importerName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("MBL NO")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo1",
      "name": "mblNo1"
    },
    model: {
      value: (_vm.AuthModel.mblNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "mblNo", $$v)
      },
      expression: "AuthModel.mblNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Current Date & Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.AuthModel.currentDate),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "currentDate", $$v)
      },
      expression: "AuthModel.currentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Container No./ Seal No.")]), _vm._v(" "), _c('quill-editor', {
    ref: "containerSealNo",
    model: {
      value: (_vm.AuthModel.containerSealNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "containerSealNo", $$v)
      },
      expression: "AuthModel.containerSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Authorization Letter")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "450px !important"
    },
    model: {
      value: (_vm.AuthModel.authLetter),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "authLetter", $$v)
      },
      expression: "AuthModel.authLetter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderAuth"
    },
    on: {
      "click": _vm.addAuthDocumentation
    }
  }, [_vm._v("Submit Auth")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderAuth"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), (_vm.AuthModel.ffairAuthId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderAuth"
    },
    on: {
      "click": function($event) {
        _vm.Print('ConAuthDoc', _vm.AuthModel.uploadAuthDoc)
      }
    }
  }, [_vm._v("Print")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopData",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.ProceedSail
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8425e4e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/conSeaImport/seaConNocImportDocumentation.vue
// module id = 2827
// module chunks = 0